import cx from 'classnames';
import type { ReactNode } from 'react';

interface ChatStageProps {
  header: ReactNode;
  body?: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export function ChatStage({ header, body, footer, className }: ChatStageProps) {
  return (
    <div
      className={cx(
        'tw-flex',
        'tw-flex-col',
        'tw-h-full',
        'tw-min-h-0',
        className,
      )}
    >
      <div className="tw-shrink-0">{header}</div>
      <div
        className={cx(
          'tw-flex',
          'tw-flex-col',
          'tw-flex-1',
          'tw-min-h-0',
          'tw-overflow-hidden',
        )}
      >
        {body}
      </div>
      {footer && <div className="tw-shrink-0">{footer}</div>}
    </div>
  );
}
